import { render, staticRenderFns } from "./topbar.vue?vue&type=template&id=456a1f8e&scoped=true"
import script from "./topbar.vue?vue&type=script&lang=js"
export * from "./topbar.vue?vue&type=script&lang=js"
import style0 from "./topbar.vue?vue&type=style&index=0&id=456a1f8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456a1f8e",
  null
  
)

export default component.exports